const getAPIPrefix = () => {
    if (window.location.hostname.includes('prod') || window.location.hostname.includes('d2b5b1ufmkqmcn.cloudfront.net')) {
        return 'https://prod-api-f45812482b387606a614a1e3e120be68.haua.io/api';
    } else if (window.location.hostname.includes('admin-portal.haua.io') || window.location.hostname.includes('d3efbkwbg06p7l.cloudfront.net')) {
        return 'https://dev-api-zrvsvrxrgs.haua.io/api';
    } 
    else {
        return 'https://dev-api-zrvsvrxrgs.haua.io/api'
    }
}

const appConfig = {
    apiPrefix: getAPIPrefix(),
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '',
    enableMock: false
}




export default appConfig